// After the event stream ends, reconnect only if the server says the feature is still on. The
// server closes the stream itself on switch-off, and reconnecting would just bounce off a 403.
export function shouldReconnect(status) {
  return !!(status && status.enabled);
}

// Only the feature switch's own 403 means "switched off"; any other 403 (not an admin, a proxy)
// is an ordinary error and must not show the switched-off screen.
export const DISABLED_CODE = 'CLAUDECHAT_DISABLED';
export function isDisabledError(e) {
  return e?.response?.status === 403 && e.response.data?.code === DISABLED_CODE;
}

// What the hook does with the event stream's HTTP answer (code = the JSON body's code, if read):
// ok, disabled, expired (401), notfound (404), fatal (other 4xx: retrying cannot help)
// or retry (5xx: sidecar offline or a server hiccup).
export function streamOutcome(status, code) {
  if (status >= 200 && status < 300) return 'ok';
  if (status === 403 && code === DISABLED_CODE) return 'disabled';
  if (status === 401) return 'expired';
  if (status === 404) return 'notfound';
  if (status >= 400 && status < 500) return 'fatal';
  return 'retry';
}
